import { Avatar } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import { SectionLabel } from '../shared/index.js';

/**
 * Who requested the review and why. Matches the prototype REQUEST block:
 * avatar + sender (13px/600) + role (11px muted), then the reason in a tinted
 * rounded box (`.etb-reason-note`).
 */
function RequestBlock({ detail }) {
  const { t } = useTranslation('work-queues-app');
  const requester = detail?.requestedBy;
  if (!requester && !detail?.requestReason) return null;

  return (
    <div>
      <SectionLabel>{t('govReview.request')}</SectionLabel>

      {requester && (
        <div className="flex items-center gap-2.5">
          <Avatar
            size="md"
            initials={requester.initials}
            alt={requester.name}
            className="border-transparent bg-[#2173FF]/15 text-[10px] font-bold text-content"
          />
          <div>
            <p className="text-[13px] font-semibold leading-tight text-content">{requester.name}</p>
            <p className="text-[11px] text-content-faint">
              {[requester.role, detail?.requestedAt].filter(Boolean).join(' · ')}
            </p>
          </div>
        </div>
      )}

      {detail?.requestReason && (
        <p className="mt-2.5 rounded-lg border border-edge bg-surface-muted px-3 py-2 text-xs leading-relaxed text-content-secondary">
          {detail.requestReason}
        </p>
      )}
    </div>
  );
}

export default RequestBlock;
